// Finish/variant name aliases per storefront language. Keep in sync with the
// aliases used in getMatchedPriceValue() in config-product.js — the variant's
// displayed title/option value is translated per locale (de/fr/it/es), so
// exact German string matches ('Klassik Matt' / 'Deluxe Glasoptik') break on
// non-German storefronts. Match by alias instead of relying on one language.
// var, not const: this script can be re-executed (e.g. after an AJAX section
// re-render rebinds handlers to fresh DOM), and a top-level const/let throws
// "already declared" on a second run, aborting everything after it.
function ccT(k, d) { var m = window.CC_I18N || {}; return m[k] ? m[k] : d; }

var KLASSIK_MATT_ALIASES = ['klassik matt', 'opaco', 'mate', 'mat'];
var DELUXE_GLASOPTIK_ALIASES = ['deluxe glasoptik', 'effetto vetro', 'óptica de vidrio', 'aspect verre'];

function isKlassikMattVariant(name) {
  if (!name) return false;
  const lower = name.toLowerCase();
  return KLASSIK_MATT_ALIASES.some(alias => lower.includes(alias));
}

function isDeluxeGlasoptikVariant(name) {
  if (!name) return false;
  const lower = name.toLowerCase();
  return DELUXE_GLASOPTIK_ALIASES.some(alias => lower.includes(alias));
}

document.addEventListener("DOMContentLoaded", function () {

  productMediaGallrySlider();
  productSampleMediaSlider();

  // value proposition after before scroll
  if (document.querySelector(".value-proposition-container")) {
    const container = document.querySelector(".value-proposition-container");
    document.querySelector(".value-proposition-slider").addEventListener("input", (e) => {
      container.style.setProperty("--position", `${e.target.value}%`);
    });
  }

  //configure-banner section coupon code button
  const configureBannerCouponButton = document.querySelector('.configure-banner .configure-coupon-btn');
  if (configureBannerCouponButton) {
    const couponCodeSpan = configureBannerCouponButton.querySelector('.coupon--code');
    const originalCouponText = couponCodeSpan ? couponCodeSpan.textContent : '';

    configureBannerCouponButton.addEventListener('click', () => {
      const couponCode = couponCodeSpan.textContent.trim();
      // Check if the Clipboard API is available
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(couponCode)
          .then(() => {
            //console.log('Coupon code copied to clipboard:', couponCode);
            couponCodeSpan.textContent = 'Kopiert!';

            // Revert text after setTimeout
            setTimeout(() => {
              couponCodeSpan.textContent = originalCouponText;
            }, 1500);
          })
          .catch(err => {
            //console.error('Failed to copy coupon code: ', err);
          });
      } else {
        //console.log('Clipboard API not available.');
      }
    });
  }
  
  // testimonial slider
  if (document.querySelector(".testimonials-section .swiper-container")) {
    new Swiper(".testimonials-section .swiper-container", {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      freeMode: false,
      grabCursor: true,
      navigation: {
        nextEl: document.querySelector(".testimonials-section .swiper-button-next"),
        prevEl: document.querySelector(".testimonials-section .swiper-button-prev")
      },
      pagination: {
        el: document.querySelector(".testimonials-section .swiper-pagination"),
        clickable: true,
        type: "bullets"
      },
      breakpoints: {
        750: { slidesPerView: 2, spaceBetween: 20 },
        990: { slidesPerView: 2.1, spaceBetween: 50 }
      }
    });
  }
  
  
  // config-structure page bullet-1 popup faq
  var faqEle = document.querySelectorAll(".how-to-measure--modal .faq-que");
  if(faqEle.length){
    const faqs = document.querySelectorAll(".faq-que");
    faqs.forEach((faq) => {
      faq.onclick = function () {
        this.classList.toggle("is-open");
        let content = this.nextElementSibling;
        if (content.style.maxHeight) {
          //this is if the faq is open
          content.style.maxHeight = null;
        } else {
          //if the faq is currently closed
          content.style.maxHeight = content.scrollHeight + "px";
        }
      };
    });
  }

  
  //config-structure main template mobile slider
  if (document.querySelector(".config-main-product [data-mobile-config-slider]") && window.matchMedia("(max-width: 989px)").matches) {
    let swiper = new Swiper(".config-main-product [data-mobile-config-slider]", {
      slidesPerView: 1,
      effect: 'fade',
      speed: 550,
      allowTouchMove: false,
      touchStartPreventDefault: false, // allow pinch gestures
      passiveListeners: true, // lets browser handle zoom
      autoHeight: true,
      navigation: {
        nextEl: "[data-mobile-config-slider] .swiper-button-next",
        prevEl: "[data-mobile-config-slider] .swiper-button-prev"
      },
      pagination: {
        el: "[data-mobile-config-slider] .swiper-pagination",
        clickable: true
      },
    });
  }

  //creat a draft order when checkout button is clicked
  // document.addEventListener('click', function(e) {
  //   let target = e.target;
  //   let checkoutBtnTarget = target.closest('[data-draft-order-trigger]');
  //   //checkout button is clicked
  //   if(checkoutBtnTarget){
  //     e.preventDefault();
  //     creatDraftOrder(checkoutBtnTarget);
  //   }
  // });


  //product sample page
  const sampleProductPageEle = document.querySelector(".template-sample");
  if(sampleProductPageEle){
    
    //product sample page drawer search open
    const sampleSearchEle = document.querySelector(".product-sample-modal [data-open-search]");

    if (sampleSearchEle) {
      sampleSearchEle.addEventListener('click', function (e) {
        e.preventDefault();

        const modal = e.target.closest('modal-dialog');
        if (!modal) return;

        const searchForm = modal.querySelector('.product-picker-form');
        const headingWrap = modal.querySelector('.picker-step-title');

        if (!searchForm || !headingWrap) return;

        const isOpen = searchForm.style.display === 'block';

        if (!isOpen) {
          // OPEN SEARCH
          searchForm.style.display = 'block';
          headingWrap.style.display = 'none';

          // autofocus input
          const input = searchForm.querySelector('input[type="search"]');
          if (input) input.focus();
        } else {
          // CLOSE SEARCH
          searchForm.style.display = 'none';
          headingWrap.style.display = '';
        }
      });

      handleSampleProductSearch();
    }
  
    //product sample page drawer item selection
    handleSampleProductSelection();  

    //product sample page drawer variant quick view
    SampleProductQuickViewSlider();

    //product sample page drawer variant quick view confirm select button
    const motiveConfirmBtn = document.querySelectorAll("[data-confirm-motiv]");
    if(motiveConfirmBtn.length){
      motiveConfirmBtn.forEach(el => {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          const currId = e.target.closest('[data-variant-id]').getAttribute('data-variant-id');
          if(currId){
            e.target.closest('modal-dialog').querySelector(`[data-product-picker-grid] [data-variant-id="${currId}"] [data-select-variant]`).click();
            e.target.closest('modal-dialog').querySelector('.product-popup-modal__content-info').classList.remove('hidden');
            e.target.closest('.sample-pro-quick-view-wrapper').querySelectorAll('.sample-pro-info-wrap').forEach(el => el.classList.add('hidden'));
          }
        });
      });
    }
  }

  //scroll event
  window.addEventListener('scroll', checkConfigureFeaturedProdSectionBtn);
  
});



function productMediaGallrySlider(){
  let productConfigureMediaGallerySlider = document.querySelectorAll('[data-desktop-layout="thumbnail_slider"] [data-configure-media-gallery-slider]');
  let productThumbConfigureMediaGallerySlider = document.querySelectorAll('[data-desktop-layout="thumbnail_slider"] [data-configure-media-gallery-thumb-slider]');

  if(!productConfigureMediaGallerySlider.length && !productThumbConfigureMediaGallerySlider.length) return;

  for (let i=0; i<productConfigureMediaGallerySlider.length; i++){
    let mainSlider = productConfigureMediaGallerySlider[i];
    let thumbSlider = productThumbConfigureMediaGallerySlider[i];

    let initThumbSwiper;
    if(thumbSlider){
      initThumbSwiper = new Swiper(thumbSlider, {
        spaceBetween: 20,
        slidesPerView: 5,
        watchSlidesProgress: true,
        navigation: {
          nextEl: thumbSlider.querySelector(".swiper-button-next"),
          prevEl: thumbSlider.querySelector(".swiper-button-prev")
        },
        breakpoints: {
          750: { slidesPerView: 5, spaceBetween: 24 }
        }
      });
    }

    if(mainSlider){
      let mediaModalSliderInit = new Swiper(mainSlider, {
        // allowTouchMove: false,
        navigation: {
          nextEl: mainSlider.querySelector(".swiper-button-next"),
          prevEl: mainSlider.querySelector(".swiper-button-prev")
        },
        thumbs: {
          swiper: initThumbSwiper
        },
        on: {
          transitionStart: function(){
            const allVideos = [...mainSlider.querySelectorAll('video, iframe')];
            if(allVideos.length) window.pauseAllMedia();
          },
          
          transitionEnd: function(){
            const activeIndex = this.activeIndex;
            const activeSlide = mainSlider.querySelectorAll('.swiper-slide')[activeIndex];
            const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
            if(activeSlideVideo) activeSlideVideo.play();
            //for external video
            const activeSlideIframe = activeSlide.getElementsByTagName('iframe')[0];
            if(activeSlideIframe){
              let iframeSrc = activeSlideIframe.getAttribute('src');
              if(iframeSrc.includes('?autoplay=0')){
                let newSrc = iframeSrc.replace('?autoplay=0','?autoplay=1&muted=1');
                activeSlideIframe.setAttribute('src',newSrc);
              }
              if(iframeSrc.includes('vimeo.com')){
                activeSlideIframe.contentWindow.postMessage('{"method":"play"}', '*');
              }else{
                activeSlideIframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
              }
            }
          }
        }
      });
    }
  }
}

function productSampleMediaSlider(){
  let productSampleMediaGallerySlider = document.querySelectorAll('[data-desktop-layout="thumbnail_slider"] [data-sample-media-gallery-slider]');
  let productThumbSampleMediaGallerySlider = document.querySelectorAll('[data-desktop-layout="thumbnail_slider"] [data-sample-media-gallery-thumb-slider]');

  if(!productSampleMediaGallerySlider.length && !productThumbSampleMediaGallerySlider.length) return;

  for (let i=0; i<productSampleMediaGallerySlider.length; i++){
    let mainSlider = productSampleMediaGallerySlider[i];
    let thumbSlider = productThumbSampleMediaGallerySlider[i];

    let initThumbSwiper;
    if(thumbSlider){
      initThumbSwiper = new Swiper(thumbSlider, {
        direction: 'vertical',
        spaceBetween: 18,
        slidesPerView: 5,
        watchSlidesProgress: true,
        navigation: {
          nextEl: thumbSlider.parentElement?.querySelector(".swiper-button-next"),
          prevEl: thumbSlider.parentElement?.querySelector(".swiper-button-prev")
        }
      });
    }

    if(mainSlider){
      let mediaModalSliderInit = new Swiper(mainSlider, {
        // allowTouchMove: false,
        navigation: {
          nextEl: mainSlider.querySelector(".swiper-button-next"),
          prevEl: mainSlider.querySelector(".swiper-button-prev")
        },
        thumbs: {
          swiper: initThumbSwiper
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          transitionStart: function(){
            const allVideos = [...mainSlider.querySelectorAll('video, iframe')];
            if(allVideos.length) window.pauseAllMedia();
          },
          
          transitionEnd: function(){
            const activeIndex = this.activeIndex;
            const activeSlide = mainSlider.querySelectorAll('.swiper-slide')[activeIndex];
            const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
            if(activeSlideVideo) activeSlideVideo.play();
            //for external video
            const activeSlideIframe = activeSlide.getElementsByTagName('iframe')[0];
            if(activeSlideIframe){
              let iframeSrc = activeSlideIframe.getAttribute('src');
              if(iframeSrc.includes('?autoplay=0')){
                let newSrc = iframeSrc.replace('?autoplay=0','?autoplay=1&muted=1');
                activeSlideIframe.setAttribute('src',newSrc);
              }
              if(iframeSrc.includes('vimeo.com')){
                activeSlideIframe.contentWindow.postMessage('{"method":"play"}', '*');
              }else{
                activeSlideIframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
              }
            }
          }
        },
      });
    }
  }
}

async function getCurrentCartJson() {
  try {
    const response = await fetch(`${routes.cart_url}.js`);
    if (!response.ok) {
      const errorText = await response.text();
      return null;
    }
    const cartData = await response.json();
    return cartData;
  } catch (error) {
    console.error('Error fetching cart json:', error);
    return null;
  }
}

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }
    
    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

function creatDraftOrder(event) {
  event.preventDefault();
  const btn = event.target.closest('[data-draft-order-trigger]');
  btn.setAttribute('aria-disabled', true);
  btn.classList.add('loading');
  btn.querySelector('.loading-overlay__spinner').classList.remove('hidden');

  let dimensionsKeyLable, typeKeyLable;
  switch(Shopify?.locale) {
    case `de`:
      dimensionsKeyLable = `Maß`;
      typeKeyLable = `Ausführung`;
      break;
    case `it`:
      dimensionsKeyLable = `Dimensioni`;
      typeKeyLable = `Variante`;
      break;
    case `es`:
      dimensionsKeyLable = `Dimensiones`;
      typeKeyLable = `Variante`;
      break;
    case `fr`:
      dimensionsKeyLable = `Dimensions`;
      typeKeyLable = `Variante`;
      break;
    default:
      dimensionsKeyLable = `Maß`;
      typeKeyLable = `Ausführung`;
  }

  getCurrentCartJson()
    .then(cart => {
      if (cart) {
        //console.log('Current Cart JSON:', cart);
        const filteredItems = [];
        let samplePushed = false;
        for(i=0; i<cart.items.length; i++){
          if(cart.items[i].properties['_customise_product'] && cart.items[i].properties['_customise_product'] != ''){
            //FOR CUSTOM CONFIGURE PRODUCTS
            const customAttributesArry = [];
            if (cart.items[i].properties['Maß'] && cart.items[i].properties['Maß'] != '') {
              customAttributesArry.push({
                "key": dimensionsKeyLable,
                "value": cart.items[i].properties['Maß']
              });
            }
            if (cart.items[i].properties['_Ausführung'] && cart.items[i].properties['_Ausführung'] != '') {
              customAttributesArry.push({
                "key": typeKeyLable,
                "value": cart.items[i].properties['_Ausführung']
              });
            }
            if (cart.items[i].properties['_SKU'] && cart.items[i].properties['_SKU'] != '') {
              customAttributesArry.push({
                "key": "SKU",
                "value": cart.items[i].properties['_SKU']
              });
            }
            if (cart.items[i].properties['_crop_x'] && cart.items[i].properties['_crop_x'] != '') {
              customAttributesArry.push({
                "key": "_crop_x",
                "value": cart.items[i].properties['_crop_x']
              });
            }
            if (cart.items[i].properties['_crop_y'] && cart.items[i].properties['_crop_y'] != '') {
              customAttributesArry.push({
                "key": "_crop_y",
                "value": cart.items[i].properties['_crop_y']
              });
            }
            if (cart.items[i].properties['_crop_width'] && cart.items[i].properties['_crop_width'] != '') {
              customAttributesArry.push({
                "key": "_crop_width",
                "value": cart.items[i].properties['_crop_width']
              });
            }
            if (cart.items[i].properties['_crop_height'] && cart.items[i].properties['_crop_height'] != '') {
              customAttributesArry.push({
                "key": "_crop_height",
                "value": cart.items[i].properties['_crop_height']
              });
            }
            if (cart.items[i].properties['_original_sku'] && cart.items[i].properties['_original_sku'] != '') {
              customAttributesArry.push({
                "key": "_original_sku",
                "value": cart.items[i].properties['_original_sku']
              });
            }
            if (cart.items[i].properties['_print_width_cm'] && cart.items[i].properties['_print_width_cm'] != '') {
              customAttributesArry.push({
                "key": "_print_width_cm",
                "value": cart.items[i].properties['_print_width_cm']
              });
            }
            if (cart.items[i].properties['_print_height_cm'] && cart.items[i].properties['_print_height_cm'] != '') {
              customAttributesArry.push({
                "key": "_print_height_cm",
                "value": cart.items[i].properties['_print_height_cm']
              });
            }
            if (cart.items[i].properties['_frontend_width'] && cart.items[i].properties['_frontend_width'] != '') {
              customAttributesArry.push({
                "key": "_frontend_width",
                "value": cart.items[i].properties['_frontend_width']
              });
            }
            if (cart.items[i].properties['_number_of_loop_image'] && cart.items[i].properties['_number_of_loop_image'] != '') {
              customAttributesArry.push({
                "key": "_number_of_loop_image",
                "value": cart.items[i].properties['_number_of_loop_image']
              });
            }
            if (cart.items[i].properties['_frontend_height'] && cart.items[i].properties['_frontend_height'] != '') {
              customAttributesArry.push({
                "key": "_frontend_height",
                "value": cart.items[i].properties['_frontend_height']
              });
            }
            const itemDetails = {
              // "variantId": cart.items[i].variant_id,
              "title": cart.items[i].title,
              "amount": (Number(cart.items[i].properties['_price'])/100),
              "quantity": cart.items[i].quantity,
              "sku": cart.items[i].properties['_SKU'],
              "currency_code": Shopify.currency?.active || "EUR",
              "customAttributes": customAttributesArry
            };
            filteredItems.push(itemDetails);
          }else if(cart.items[i].properties['_sampleProducts'] && cart.items[i].properties['_sampleProducts'] != ''){
            //FOR MUSTER SET PRODUCTS — 3-fuer-2 wird hier stueckgenau neu
            //berechnet (2 voll, das 3. gratis, weitere reduziert), unabhaengig
            //von den ggf. veralteten _price-Properties im Cart
            if(!samplePushed){
              buildSampleDraftLines(cart.items).forEach(line => filteredItems.push(line));
              samplePushed = true;
            }
          }else{
            //FOR ALL OTHER PRODUCTS
            const customAttributesArry = [];
            if(Object.keys(cart.items[i].properties).length){
              Object.entries(cart.items[i].properties).forEach(([key, value]) => {
                customAttributesArry.push({ "key": key, "value": value.toString() });
              });
            }
            const itemDetails = {
              "variantId": cart.items[i].variant_id,
              "quantity": cart.items[i].quantity,
              "currency_code": Shopify.currency?.active || "EUR",
              "customAttributes": customAttributesArry
            };
            filteredItems.push(itemDetails);
          }
        }
        const cartAttributesArry = [];
        if(Object.keys(cart.attributes).length){
          Object.entries(cart.attributes).forEach(([key, value]) => {
            cartAttributesArry.push({ "key": key, "value": value.toString() });
          });
        }
        const options = {
          method: "POST",
          headers: { "content-type": "application/json"},
          body: JSON.stringify({
            "lineItems": filteredItems,
            "customAttributes": cartAttributesArry,
            // Storefront country (e.g. "FR" on danario.fr, "DE" on danario.de) —
            // draft_order.php should use this as the draft order's
            // shippingAddress.countryCode so the checkout country field
            // defaults correctly instead of falling back to the shop's base
            // country (Germany) for every storefront.
            "countryCode": Shopify?.country || null
          })
        };
        //console.log(`options >>`,options);
        const draftOrderId = localStorage.getItem('draft_order_id');
        callDraftOrderAPI(draftOrderId,options,btn)
      } else {
        console.log('Could not retrieve cart data.');
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    });
}

function callDraftOrderAPI(id,data,btn) {
  let url = `https://app.danario.de/deaft_order/draft_order.php`;
  if(id){
    url = `https://app.danario.de/deaft_order/draft_order.php?id=${id}`;
  }
  fetch(url,data)
    .then((response) => {
      if (response.status) {
        //console.log("success submitting -->",response);
        return response.json();
      } else {
        //console.log("Response Status: " + response.status);
      }
    })
    .then(result => {
      //console.log("Draft Result -->",result);
      if(result?.errors?.length){
        console.log("error processing to checkout -->");
        //show some error message
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      } else if(result.data?.draftOrderUpdate?.draftOrder == null && result.data?.draftOrderUpdate?.userErrors?.length){
        //check if draft order is alredy created? if not then draft order id is not valid creat a new draft order using new request
        localStorage.setItem('draft_order_id',null);
        callDraftOrderAPI(null,data,btn);
      } else if(result.data?.draftOrderUpdate?.draftOrder?.order?.confirmed){
        //check if draft order is alredy converted to real order? if yes then call draft order again wih empty id
        localStorage.setItem('draft_order_id',null);
        callDraftOrderAPI(null,data,btn);
      } else {
        //draft order success
        let checkoutUrl = result.data?.draftOrderCreate?.draftOrder?.invoiceUrl || result.data?.draftOrderUpdate?.draftOrder?.invoiceUrl;
        let draftOrderId = result.data?.draftOrderCreate?.draftOrder?.id || result.data?.draftOrderUpdate?.draftOrder?.id;
        let currentLocale = Shopify?.locale;
        //console.log(`checkoutUrl >>`,checkoutUrl)
        let draftOrderIdSplit = draftOrderId.split('/DraftOrder/');
        localStorage.setItem('draft_order_id',draftOrderIdSplit[1]);
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        btn.querySelector('.loading-overlay__spinner').classList.add('hidden');

        // Shopify's draftOrder.invoiceUrl always uses the shop's PRIMARY
        // domain (danario.de), regardless of which storefront domain the
        // customer is actually on — swapping only the hostname (keeping the
        // invoice's path/token/query intact) keeps them on danario.fr/.it/etc.
        // instead of silently bouncing them to danario.de. Locale is set via
        // URLSearchParams rather than string concatenation, since invoiceUrl
        // typically already carries its own "?key=..." query string.
        try {
          const checkoutUrlObj = new URL(checkoutUrl);
          checkoutUrlObj.hostname = window.location.hostname;
          if (currentLocale) {
            checkoutUrlObj.searchParams.set('locale', currentLocale);
          }
          checkoutUrl = checkoutUrlObj.toString();
        } catch (e) {
          console.error('Failed to adapt checkout URL to current storefront domain', e);
        }

        location.href = checkoutUrl; // redirect to checkout page with relevant locales
      }
    })
    .catch((err) => {
      console.error(`error >>`,err);
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
      btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
}


function toggleAccordion(element) {
  const openClass = "acc--open";
  const mainParent = document.querySelectorAll("[data-accordian-tab]");
  const currentParent = element.closest("[data-accordian-tab]");
  const content = currentParent.querySelector("[data-accordian-desc]");

  if (currentParent.classList.contains(openClass)) {
    currentParent.classList.remove(openClass);
    currentParent.querySelector("[data-accordian-desc]").style.maxHeight = "0px";
  } else {
    mainParent.forEach((e) => {
      if (e.classList.contains(openClass)) {
        e.classList.remove(openClass);
        e.querySelector("[data-accordian-desc]").style.maxHeight = "0px";
      }
    });
    currentParent.classList.add(openClass);
    content.style.maxHeight = `${content.scrollHeight + 10}px`;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const firstTab = document.querySelector("[data-accordian-tab]");
  // if (firstTab) {
  //   const content = firstTab.querySelector("[data-accordian-desc]");
  //   firstTab.classList.add("acc--open");
  //   content.style.maxHeight = content.scrollHeight + 10 + "px";
  // }
});


function checkConfigureFeaturedProdSectionBtn() {
  const FeaturedProdSectionBtn = document.querySelector('.configure-featured-product product-info .product-info__button');  
  if (!FeaturedProdSectionBtn) return;
  
  const rect = FeaturedProdSectionBtn.getBoundingClientRect();
  // Check if the bottom of the button element has gone above the top of the viewport
  const isPastViewport = rect.bottom < 0;

  if (isPastViewport) {
    document.body.classList.add('sticky-btn-active');
  } else {
    document.body.classList.remove('sticky-btn-active');
  }
}

function handleSampleProductSearch(){
  const searchInput = document.querySelector('[data-product-picker-form] input');
  const searchButton = document.querySelector('[data-product-picker-form] button');
  const productGridItems = document.querySelectorAll('[data-product-picker-grid] .grid__item');

  if (!searchInput || !productGridItems.length && !productGridItems.length) return;

  const filterProducts = () => {
    const searchTerm = searchInput.value.trim().toLowerCase();
    productGridItems.forEach(item => {
      const dataTitle = item.dataset.title;
      if (dataTitle) {
        if (dataTitle.toLowerCase().includes(searchTerm)) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      } else {
        // If an item doesn't have data-title, decide if it should be hidden or shown by default
        // For now, let's hide it if no data-title is present and there's a search term
        if (searchTerm.length > 0) {
            item.classList.add('hidden');
        } else {
            item.classList.remove('hidden'); // Show if no search term
        }
      }
    });
  };

  // Event listener for typing in the search input
  searchInput.addEventListener('input', filterProducts);

  searchInput.addEventListener('keyup', (event) => {
    if (event.key === 'Escape' || searchInput.value.trim() === '') {
      // If Esc is pressed or input is empty, show all items
      productGridItems.forEach(item => {
        item.classList.remove('hidden');
      });
    }
  });

  // Event listener for clicking the search button
  if (searchButton) {
    searchButton.addEventListener('click', (event) =>{
      event.preventDefault();
      filterProducts();
    });
  }

  // Also handle clearing search if user just types and deletes everything
  searchInput.addEventListener('input', () => {
    if (searchInput.value.trim() === '') {
      productGridItems.forEach(item => item.classList.remove('hidden'));
    }
  });

}
document.addEventListener('change', function (e) {
  if (!e.target.matches('variant-radio input[type="radio"]')) return;

  const radio = e.target;

  if (!radio.checked) return;

  const label = document.querySelector(`label[for="${radio.id}"]`);
  if (!label) return;

  const variantNameEle = label.querySelector('.variant-name');
  const variantName = variantNameEle ? variantNameEle.textContent.trim() : null;

  updateSampleTemplate(variantName);
});

function updateSampleTemplate(variantName) {
  const wrapper = document.querySelector('.product-step-wrapper');
  if (!wrapper) return;

  const patternText = wrapper.querySelector('.patterns-text');
  if (!patternText) return;
  patternText.textContent = variantName;
  const modalOpener = wrapper.querySelector('.selected-motive-grid-item');
  if (!modalOpener) return;
  modalOpener.classList.remove(
    'glasoptik-popup',
    'klassik-mat-popup'
  );
  const modaldialog = document.querySelector('.sample-product-wrpper');
  if (!modaldialog) return;
  modaldialog.classList.remove(
    'glasoptik-popup',
    'klassik-mat-popup'
  );
  const productgrid = modaldialog.querySelectorAll('.grid__item');

  productgrid.forEach(item => {
    const categoryType = item.getAttribute('data-category-type');

    // Match by finish FAMILY (Klassik Matt vs Deluxe Glasoptik), not exact
    // text: categoryType comes from the "muster" utility product (which has
    // no French/IT/ES translations and is always German), while variantName
    // comes from the sample product's own (translated) finish selector. An
    // exact-string match would never succeed on non-German storefronts.
    const sameFamily =
      (isKlassikMattVariant(categoryType) && isKlassikMattVariant(variantName)) ||
      (isDeluxeGlasoptikVariant(categoryType) && isDeluxeGlasoptikVariant(variantName));

    if (categoryType && sameFamily) {
      item.style.display = '';        // show matching
    } else {
      item.style.display = 'none';    // hide others
    }
  });


  const showselectedmotiv = document.querySelector('.selected-motive-grid');
  const productpickergrid = document.querySelector('[data-product-picker-grid]');

  if (modalOpener.classList.contains('filled')) {
    if(showselectedmotiv){
      showselectedmotiv.style.display = 'block';
    }
    if(productpickergrid){
      productpickergrid.classList.add('hidden');
    }
  }else{
    if(showselectedmotiv){
    showselectedmotiv.style.display = 'none';
    }
    if(productpickergrid){
      productpickergrid.classList.remove('hidden');
    }
  }


  if (isKlassikMattVariant(variantName)) {
    modalOpener.classList.add('klassik-mat-popup');
    modaldialog.classList.add('klassik-mat-popup');
  }
  if (isDeluxeGlasoptikVariant(variantName)) {
    modalOpener.classList.add('glasoptik-popup');
    modaldialog.classList.add('glasoptik-popup');
  }

  const modal = document.querySelector('.sample-product-wrpper');
  if (!modal) return;

  // Remove both possible classes first
    const selectedVariantTitle = modalOpener?.getAttribute('data-selected-variant-title');
    if (!selectedVariantTitle) return;

    const match = selectedVariantTitle.match(/^(.+?)\s*\((.+?)\)$/);

    if (!match) return;

    const motif = match[1].trim();       // "Schiefer" (display text — may already be translated)

    // Re-locate the grid item by the variant ID stored when the motif was
    // picked (numeric, translation-independent) instead of matching by title
    // text: `motif` here can already be translated (e.g. Weglot translating
    // the visible ".product-title" text at selection time), while data-title
    // on the grid item always embeds the untranslated German motif name from
    // the "muster" product — an exact-text match between the two would fail.
    const selectedVariantId = modalOpener.getAttribute('data-selected-variant-id');
    if (!selectedVariantId) return;

    const matchedProduct = modal.querySelector(`.picker-product[data-variant-id="${selectedVariantId}"]`);

    if (!matchedProduct) return;

    const img = matchedProduct.querySelector('img.product-image');
    const currentVariantId = matchedProduct.getAttribute('data-variant-id');
    const currentVariantPrice = matchedProduct.getAttribute('data-variant-price');
    const pdpinfohtmlAppend = matchedProduct.querySelector('.product-view-btn');

    const imageSrc = img.src;
  // Add correct class
  if (isKlassikMattVariant(variantName)) {
    if(document.querySelectorAll('.selected-motive-grid-item.klassik-mat-popup').length){
        document.querySelectorAll('.selected-motive-grid-item.klassik-mat-popup').forEach(el => {
          if(el.classList.contains('active')){
            // additionalBoxHTML = el.outerHTML;
            if(el.querySelector('.patterns-box .patterns-box-img')){
              el.querySelector('.patterns-box .patterns-box-img').remove();
            }
            const patternsText = el.querySelector('.patterns-text');
            const patternsBox = el.querySelector('.patterns-box');
            let categoryText = patternsBox.previousElementSibling;

            if (categoryText && categoryText.classList.contains('category-text')) {
              // Update existing text
              categoryText.textContent = variantName;
            } else {
              // Insert new one
              patternsBox.insertAdjacentHTML(
                'beforebegin',
                `<span class="category-text">${variantName}</span>`
              );
            }
            let selectionEleTitle = patternsText;
            if(selectionEleTitle) selectionEleTitle.innerHTML = `${motif}`;
            let htmlToBeAppend = `<span class="patterns-box-img">
                                    <img src="${imageSrc}" width="" height="">
                                    <span class="icon-close" onclick="resetSampleProductSelection(event)"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M13.333 13.3334L26.6663 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path><path d="M26.667 13.3334L13.3337 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                                  </span>`;
            patternsBox.innerHTML += htmlToBeAppend;
            el.setAttribute('data-selected-variant-id',currentVariantId);
            el.setAttribute('data-selected-variant-title',`${motif} (${variantName})`);
            el.setAttribute('data-selected-variant-price',currentVariantPrice);
            // Get button (it may have been inside patterns-box)
            
            if (!pdpinfohtmlAppend) return;

            // Remove existing appended block inside this element (if any)
            const existingInfoBlock = el.querySelector('.pdp-info-block');
            if (existingInfoBlock) {
              existingInfoBlock.remove();
            }

            // Clone to avoid DOM relocation issues
            const newBlock = pdpinfohtmlAppend.cloneNode(true);
            newBlock.classList.add('pdp-info-block');

            // Insert after patternsText
            patternsText.insertAdjacentElement('afterend', newBlock);
            el.classList.add('filled');
          }
        });
      }
  }
  if (isDeluxeGlasoptikVariant(variantName)) {
    if(document.querySelectorAll('.selected-motive-grid-item.glasoptik-popup').length){
        document.querySelectorAll('.selected-motive-grid-item.glasoptik-popup').forEach(el => {
          if(el.classList.contains('active')){
            // additionalBoxHTML = el.outerHTML;
            if(el.querySelector('.patterns-box .patterns-box-img')){
              el.querySelector('.patterns-box .patterns-box-img').remove();
            }
            const patternsText = el.querySelector('.patterns-text');
            const patternsBox = el.querySelector('.patterns-box');
            let categoryText = patternsBox.previousElementSibling;

            if (categoryText && categoryText.classList.contains('category-text')) {
              // Update existing text
              categoryText.textContent = variantName;
            } else {
              // Insert new one
              patternsBox.insertAdjacentHTML(
                'beforebegin',
                `<span class="category-text">${variantName}</span>`
              );
            }
            let selectionEleTitle = patternsText;
            if(selectionEleTitle) selectionEleTitle.innerHTML = `${motif}`;
            let htmlToBeAppend = `<span class="patterns-box-img">
                                    <img src="${imageSrc}" width="" height="">
                                    <span class="icon-close" onclick="resetSampleProductSelection(event)"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M13.333 13.3334L26.6663 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path><path d="M26.667 13.3334L13.3337 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                                  </span>`;
            patternsBox.innerHTML += htmlToBeAppend;
            el.setAttribute('data-selected-variant-id',currentVariantId);
            el.setAttribute('data-selected-variant-title',`${motif} (${variantName})`);
            el.setAttribute('data-selected-variant-price',currentVariantPrice);
            if (!pdpinfohtmlAppend) return;

            // Remove existing appended block inside this element (if any)
            const existingInfoBlock = el.querySelector('.pdp-info-block');
            if (existingInfoBlock) {
              existingInfoBlock.remove();
            }

            // Clone to avoid DOM relocation issues
            const newBlock = pdpinfohtmlAppend.cloneNode(true);
            newBlock.classList.add('pdp-info-block');

            // Insert after patternsText
            patternsText.insertAdjacentElement('afterend', newBlock);
            el.classList.add('filled');
          }
        });
      }
  }
  handleSampleProductADD();
    
}


function handleSampleProductSelection() {
  const gridItem = document.querySelectorAll('[data-product-picker-grid] [data-select-variant]');
  if(!gridItem.length) return;

  gridItem.forEach(grid => {
    grid.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const allmotivemodal = document.querySelector('.sample-product-wrpper');
      allmotivemodal.classList.remove(
        'glasoptik-popup',
        'klassik-mat-popup'
      );
      const selected_grid_item = document.querySelector('.selected-motive-grid-item');
      selected_grid_item.classList.remove(
        'glasoptik-popup',
        'klassik-mat-popup'
      );

      let currentCategory = e.target.closest('[data-category-type]').getAttribute('data-category-type');
      let currentVariantId = e.target.closest('[data-category-type]').getAttribute('data-variant-id');
      let currentVariantPrice = e.target.closest('[data-category-type]').getAttribute('data-variant-price');
      let currentImg = e.target.closest('[data-category-type]').querySelector('img').getAttribute('src');
      let currentTitle = e.target.closest('[data-category-type]').querySelector('.product-title').textContent;
      let pdpinfohtmlAppend = e.target.closest('[data-category-type]').querySelector('.product-view-btn');
      let additionalBoxHTML;
      // const variantRadios = document.querySelector('#variant-radios-template--27334368624906__main');
      // if (!variantRadios) return;

      // const variantInputs = variantRadios.querySelectorAll('input[type="radio"]');

      // variantInputs.forEach(input => {
      //   if (input.value.toLowerCase() === currentCategory.toLowerCase()) {
      //     input.checked = true;

      //     // Trigger Shopify variant update
      //     input.dispatchEvent(new Event('change', { bubbles: true }));
      //   }
      // });
  
      if(isKlassikMattVariant(currentCategory)){
        allmotivemodal.classList.add('klassik-mat-popup');
        selected_grid_item.classList.add('klassik-mat-popup');
        if(document.querySelectorAll('.selected-motive-grid-item.klassik-mat-popup').length){
          document.querySelectorAll('.selected-motive-grid-item.klassik-mat-popup').forEach(el => {
          
            if(el.classList.contains('active')){
              additionalBoxHTML = el.outerHTML;
              if(el.querySelector('.patterns-box .patterns-box-img')){
                el.querySelector('.patterns-box .patterns-box-img').remove();
              }
              
              const patternsText = el.querySelector('.patterns-text');
              const patternsBox = el.querySelector('.patterns-box');
              let categoryText = patternsBox.previousElementSibling;

              if (categoryText && categoryText.classList.contains('category-text')) {
                // Update existing text
                categoryText.textContent = currentCategory;
              } else {
                // Insert new one
                patternsBox.insertAdjacentHTML(
                  'beforebegin',
                  `<span class="category-text">${currentCategory}</span>`
                );
              }
              let selectionEleTitle = patternsText;
              if(selectionEleTitle) selectionEleTitle.innerHTML = `${currentTitle}`;
              let htmlToBeAppend = `<span class="patterns-box-img">
                                      <img src="${currentImg}" width="" height="">
                                      <span class="icon-close" onclick="resetSampleProductSelection(event)"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M13.333 13.3334L26.6663 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path><path d="M26.667 13.3334L13.3337 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                                    </span>`;
              patternsBox.innerHTML += htmlToBeAppend;
              // e.target.closest('modal-dialog').querySelector('.product-popup-modal__toggle').click();
              el.setAttribute('data-selected-variant-id',currentVariantId);
              el.setAttribute('data-selected-variant-title',`${currentTitle} (${currentCategory})`);
              el.setAttribute('data-selected-variant-price',currentVariantPrice);
              if (!pdpinfohtmlAppend) return;

              // Remove existing appended block inside this element (if any)
              const existingInfoBlock = el.querySelector('.pdp-info-block');
              if (existingInfoBlock) {
                existingInfoBlock.remove();
              }

              // Clone to avoid DOM relocation issues
              const newBlock = pdpinfohtmlAppend.cloneNode(true);
              newBlock.classList.add('pdp-info-block');

              // Insert after patternsText
              patternsText.insertAdjacentElement('afterend', newBlock);
              el.classList.add('filled');
            }
          });
        }
      }

      if(isDeluxeGlasoptikVariant(currentCategory)){
        allmotivemodal.classList.add('glasoptik-popup');
        selected_grid_item.classList.add('glasoptik-popup');
        if(document.querySelectorAll('.selected-motive-grid-item.glasoptik-popup').length){
          document.querySelectorAll('.selected-motive-grid-item.glasoptik-popup').forEach(el => {
            if(el.classList.contains('active')){
              additionalBoxHTML = el.outerHTML;
              if(el.querySelector('.patterns-box .patterns-box-img')){
                el.querySelector('.patterns-box .patterns-box-img').remove();
              }
              const patternsText = el.querySelector('.patterns-text');
              const patternsBox = el.querySelector('.patterns-box');
              let categoryText = patternsBox.previousElementSibling;

              if (categoryText && categoryText.classList.contains('category-text')) {
                // Update existing text
                categoryText.textContent = currentCategory;
              } else {
                // Insert new one
                patternsBox.insertAdjacentHTML(
                  'beforebegin',
                  `<span class="category-text">${currentCategory}</span>`
                );
              }
              let selectionEleTitle = patternsText;
              if(selectionEleTitle) selectionEleTitle.innerHTML = `${currentTitle}`;
              let htmlToBeAppend = `<span class="patterns-box-img">
                                      <img src="${currentImg}" width="" height="">
                                      <span class="icon-close" onclick="resetSampleProductSelection(event)"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M13.333 13.3334L26.6663 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path><path d="M26.667 13.3334L13.3337 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                                    </span>`;
              patternsBox.innerHTML += htmlToBeAppend;
              // e.target.closest('modal-dialog').querySelector('.product-popup-modal__toggle').click();
              el.setAttribute('data-selected-variant-id',currentVariantId);
              el.setAttribute('data-selected-variant-title',`${currentTitle} (${currentCategory})`);
              el.setAttribute('data-selected-variant-price',currentVariantPrice);
              if (!pdpinfohtmlAppend) return;

              // Remove existing appended block inside this element (if any)
              const existingInfoBlock = el.querySelector('.pdp-info-block');
              if (existingInfoBlock) {
                existingInfoBlock.remove();
              }

              // Clone to avoid DOM relocation issues
              const newBlock = pdpinfohtmlAppend.cloneNode(true);
              newBlock.classList.add('pdp-info-block');

              // Insert after patternsText
              patternsText.insertAdjacentElement('afterend', newBlock);
              el.classList.add('filled');
            }
          });
        }
      }

      const showselectedmotiv = document.querySelector('.selected-motive-grid');
      if(showselectedmotiv){
        showselectedmotiv.style.display = 'block';
      }

      const productpickergrid = document.querySelector('[data-product-picker-grid]');
      if(productpickergrid){
        productpickergrid.classList.add('hidden');
      }

      //handle ATC button label
      handleSampleProductADD();
      
    });
  });
}


document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.sample-modal-klassik');
  if (!trigger) return;

  e.preventDefault();

  const modaldialog = document.querySelector('.sample-product-wrpper');
  if (!modaldialog) return;

  const productgrid = modaldialog.querySelectorAll('.grid__item');

  productgrid.forEach(item => {
    item.style.display = 'block';
  });
  const variantRadios = document.querySelectorAll('variant-radio input[type="radio"]');
  variantRadios.forEach(radio => {
    radio.checked = false;
  });
  const showselectedmotiv = document.querySelector('.selected-motive-grid');
  if(showselectedmotiv){
    showselectedmotiv.style.display = 'none';
  }
  const productpickergrid = document.querySelector('[data-product-picker-grid]');
  if(productpickergrid){
    productpickergrid.classList.remove('hidden');
  }
});

const addSampleBtn = document.getElementById('Product-sample-add');

if (addSampleBtn) {
  addSampleBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.target.closest('modal-dialog').querySelector('.product-popup-modal__toggle').click();
    
    const selectedElement = document.querySelector(
      '.selected-motive-grid-item.filled'
    );
    if (!selectedElement) {
      console.warn('No selected sample found.');
      return;
} 
    const currentVariantId = selectedElement.dataset.selectedVariantId || null;
    const variantTitle = selectedElement.dataset.selectedVariantTitle || '';
    const currentVariantPrice = selectedElement.dataset.selectedVariantPrice || null;
    const currentTitle =
      selectedElement.querySelector('.patterns-text')?.textContent.trim() || '';
    const currentImg =
      selectedElement.querySelector('.patterns-box-img img')?.getAttribute('src') || null;
    let currentCategory = '';
    const match = variantTitle.match(/\((.*?)\)/);
    if (match && match[1]) {
      currentCategory = match[1];
    }

    const emptyBoxEle = document.querySelector('modal-opener.sample-modal-klassik:not(.filled)');
    if (emptyBoxEle) {
      const el = emptyBoxEle;
      if(el.querySelector('.patterns-box .patterns-box-img')){
        el.querySelector('.patterns-box .patterns-box-img').remove();
      }
      const patternsTextEle = el.querySelector('.patterns-text');
      let selectionEleTitle = patternsTextEle;
      if(selectionEleTitle) selectionEleTitle.innerHTML = `${currentTitle} <br>${currentCategory}`;
      let htmlToBeAppend = `<span class="patterns-box-img">
                              <img src="${currentImg}" width="" height="">
                              <span class="icon-close" onclick="resetMainProductSelection(event)"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M13.333 13.3334L26.6663 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path><path d="M26.667 13.3334L13.3337 26.6667" stroke="black" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                            </span>`;
      el.querySelector('.patterns-box').innerHTML += htmlToBeAppend;
      // e.target.closest('modal-dialog').querySelector('.product-popup-modal__toggle').click();
      el.setAttribute('data-selected-variant-id',currentVariantId);
      el.setAttribute('data-selected-variant-title',`${currentTitle} (${currentCategory})`);
      el.setAttribute('data-selected-variant-price',currentVariantPrice);
      el.classList.add('filled');
    }
    //handle ATC button label
    handleSampleProductATCBtnLabel();

    //handle boxes, labels and prices (3-fuer-2 Aktion)
    syncSampleBoxes();

    const modelButton = document.querySelector('.selected-motive-grid-item');
    let defaultTitle;

    let targetParent;
    if(modelButton.closest('.klassik-mat-popup')){
      targetParent = 'klassik matt';
      defaultTitle = 'klassik matt';
    }
    else if(modelButton.closest('.glasoptik-popup')){
      targetParent = 'deluxe glasoptik';
      defaultTitle = 'deluxe glasoptik';
    }

    modelButton.removeAttribute('data-selected-variant-id');
    modelButton.removeAttribute('data-selected-variant-title');
    modelButton.removeAttribute('data-discounted-price');
    modelButton.removeAttribute('data-discounted-cmp-price');
    modelButton.removeAttribute('data-selected-variant-price');
    modelButton.classList.remove('filled');
    modelButton.querySelector('.patterns-box-img').remove();
    modelButton.querySelector('.product-view-btn').remove();
    modelButton.querySelector('.patterns-text').innerHTML = defaultTitle;
    const addbtnEle = document.querySelector('#Product-sample-add');
    if(addbtnEle){
      addbtnEle.setAttribute('disabled','disabled');
      const atcText = ccT('product_pick_finish', `Bitte Ausführung wählen`);
      addbtnEle.querySelector('[data-atc-text]').textContent = atcText;
    }
  });
}

function resetMainProductSelection(event){
  if(!event) return;
  event.preventDefault();
  event.stopPropagation();
  const target = event.target;
  const modelButton = target.closest('modal-opener');
  let defaultTitle = modelButton.getAttribute('data-default-title');

  modelButton.removeAttribute('data-selected-variant-id');
  modelButton.removeAttribute('data-selected-variant-title');
  modelButton.removeAttribute('data-discounted-price');
  modelButton.removeAttribute('data-discounted-cmp-price');
  modelButton.removeAttribute('data-selected-variant-price');
  modelButton.classList.remove('filled');
  modelButton.querySelector('.patterns-box-img').remove();
  modelButton.querySelector('.patterns-text').innerHTML = defaultTitle;
  modelButton.remove();

  //handle ATC button label
  handleSampleProductATCBtnLabel();

  //handle boxes, labels and prices (3-fuer-2 Aktion)
  syncSampleBoxes();

}

function resetSampleProductSelection(event) {
  if(!event) return;
  event.preventDefault();
  event.stopPropagation();
  const target = event.target;
  const modelButton = target.closest('.selected-motive-grid-item');
  let defaultTitle;

  let targetParent;
  if(target.closest('.klassik-mat-popup')){
    targetParent = 'klassik matt';
    defaultTitle = 'klassik matt';
  }
  else if(target.closest('.glasoptik-popup')){
    targetParent = 'deluxe glasoptik';
    defaultTitle = 'deluxe glasoptik';
  }

  modelButton.removeAttribute('data-selected-variant-id');
  modelButton.removeAttribute('data-selected-variant-title');
  modelButton.removeAttribute('data-discounted-price');
  modelButton.removeAttribute('data-discounted-cmp-price');
  modelButton.removeAttribute('data-selected-variant-price');
  modelButton.classList.remove('filled');
  modelButton.querySelector('.patterns-box-img').remove();
  modelButton.querySelector('.product-view-btn').remove();
  modelButton.querySelector('.patterns-text').innerHTML = defaultTitle;
  
 
  const modaldialog = document.querySelector('.sample-product-wrpper');
  if (!modaldialog) return;

  const productgrid = modaldialog.querySelectorAll('.grid__item');

  productgrid.forEach(item => {
    item.style.display = 'block';
  });
  const variantRadios = document.querySelectorAll('variant-radio input[type="radio"]');
  variantRadios.forEach(radio => {
    radio.checked = false;
  });
  const showselectedmotiv = document.querySelector('.selected-motive-grid');
  if(showselectedmotiv){
    showselectedmotiv.style.display = 'none';
  }
  const productpickergrid = document.querySelector('[data-product-picker-grid]');
  if(productpickergrid){
    productpickergrid.classList.remove('hidden');
  }
  const addbtnEle = document.querySelector('#Product-sample-add');
  if(addbtnEle){
    addbtnEle.setAttribute('disabled','disabled');
    const atcText = ccT('picker_add', `Hinzufügen`);
    addbtnEle.querySelector('[data-atc-text]').textContent = atcText;
  }
  // modelButton.remove();

  //handle ATC button label
  handleSampleProductADD();

  //remove additional item box
  // removeAdditionalSampleBox(targetParent);
}

function handleSampleProductQuickView(event) {
  if(!event) return;
  event.preventDefault();
  const target = event.target;
  const variantWrapper =
  target.closest('[data-variant-id]') ||
  target.closest('[data-selected-variant-id]');
  const varId = variantWrapper
  ? variantWrapper.getAttribute('data-variant-id') ||
    variantWrapper.getAttribute('data-selected-variant-id')
  : null;

  if(target.closest('modal-dialog').querySelector('.sample-pro-info-wrap') && target.closest('modal-dialog').querySelector(`.sample-pro-info-wrap[data-variant-id="${varId}"]`)){
    target.closest('modal-dialog').querySelector('.product-popup-modal__content-info').classList.add('hidden');
    target.closest('modal-dialog').querySelector(`.sample-pro-info-wrap[data-variant-id="${varId}"]`).classList.remove('hidden');
  }
}

function handleSampleProductQuickViewBack(event) {
  if(!event) return;
  event.preventDefault();
  const target = event.target;
  target.closest('.sample-pro-quick-view-wrapper').querySelectorAll('.sample-pro-info-wrap').forEach(el => el.classList.add('hidden'));
  target.closest('modal-dialog').querySelector('.product-popup-modal__content-info').classList.remove('hidden');
}

function handleSampleProductADD(){
 
  const klassikSampleEle = document.querySelector('.selected-motive-grid-item.filled');
  const addbtnEle = document.querySelector('#Product-sample-add');
  const selectedVariant = document.querySelector(
    'variant-radio input[type="radio"]:checked'
  );
  console.log("selectedVariant",selectedVariant);
    
  if(klassikSampleEle && addbtnEle && selectedVariant){
    if(klassikSampleEle.classList.contains('filled')){
      addbtnEle.removeAttribute('disabled');
      const atcText = ccT('picker_add', `Hinzufügen`);
      addbtnEle.querySelector('[data-atc-text]').textContent = atcText;
    }else{
      addbtnEle.setAttribute('disabled','disabled');
      const atcText = ccT('picker_add', `Hinzufügen`);
      addbtnEle.querySelector('[data-atc-text]').textContent = atcText;
    }
  }else{
    addbtnEle.setAttribute('disabled','disabled');
    const atcText = ccT('product_pick_finish', `Bitte Ausführung wählen`);
    addbtnEle.querySelector('[data-atc-text]').textContent = atcText;
  }
}

document.addEventListener('click', function(e) {
  // Find the closest product buttons container from the clicked element
  const formButtons = e.target.closest('.product-form__buttons');
  if (!formButtons) return; // Exit if the click wasn't inside the product buttons container

  // Find the main submit button inside that container
  const btn = formButtons.querySelector('button[id^="ProductSubmitButton-"]');

  // Check if the button is disabled
  if (btn && (btn.disabled || btn.hasAttribute('disabled') || btn.classList.contains('disabled'))) {
    const modalBtn = document.querySelector('modal-opener.sample-modal-klassik button');

    if (modalBtn) {
      e.preventDefault(); 
      e.stopPropagation(); 
      modalBtn.click();
    }
  }
});

function handleSampleProductATCBtnLabel() {
  const klassikSampleEle = document.querySelector('modal-opener.sample-modal-klassik');
  const atcBtnEle = document.querySelector('sample-product-form button[name="add"]');
  if(klassikSampleEle && atcBtnEle){
    if(klassikSampleEle.classList.contains('filled')){
      atcBtnEle.removeAttribute('disabled');
      const atcText = atcBtnEle.querySelector('[data-atc-text]')?.getAttribute('data-atc-regular-tex') || ccT('atc_upper', 'IN DEN WARENKORB');
      atcBtnEle.querySelector('[data-atc-text]').textContent = atcText;
    }else if(klassikSampleEle.classList.contains('filled')){
      atcBtnEle.setAttribute('disabled','disabled');
      const atcText = ccT('product_choose_motif', `Wähle Dein Motiv`);
      atcBtnEle.querySelector('[data-atc-text]').textContent = atcText;
    }else if(!klassikSampleEle.classList.contains('filled')){
      atcBtnEle.setAttribute('disabled','disabled');
      const atcText = ccT('product_choose_motif', `Wähle Dein Motiv`);
      atcBtnEle.querySelector('[data-atc-text]').textContent = atcText;
    }else if(!klassikSampleEle.classList.contains('filled')){
      atcBtnEle.setAttribute('disabled','disabled');
      const atcText = ccT('product_choose_motif', `Wähle Dein Motiv`);
      atcBtnEle.querySelector('[data-atc-text]').textContent = atcText;
    }
  }else{
    if(atcBtnEle){
      atcBtnEle.removeAttribute('disabled');
      const atcText = atcBtnEle.querySelector('[data-atc-text]')?.getAttribute('data-atc-regular-tex') || ccT('atc_upper', 'IN DEN WARENKORB');
      atcBtnEle.querySelector('[data-atc-text]').textContent = atcText;
    }
  }
}

/* === 3-fuer-2 Muster-Aktion ===
   Jedes 3. Muster gratis (3., 6., 9. ...), alle uebrigen voller Preis.
   Preise & Labels werden positionsbasiert vergeben (Box 3 = GRATIS).
   data-discounted-price steuert ueber sample-product-form.js die
   _price-Property und damit den echten Checkout-Preis (Draft-Order
   priceOverride). */
function getSampleActionConfig() {
  const row = document.querySelector('.patterns-blocks-row[data-sample-price]');
  if (!row) return null;
  const price = Number(row.getAttribute('data-sample-price')) || Number(row.getAttribute('data-current-prod-price')) || 0;
  const discountPercent = Number(row.getAttribute('data-discount-percent')) || 50;
  return {
    row: row,
    price: price,
    discountPercent: discountPercent,
    reducedPrice: Math.round(price * (100 - discountPercent) / 100),
    freeLabel: row.getAttribute('data-free-label') || 'GRATIS'
  };
}

let sampleBoxTemplateHTML = null;

function syncSampleBoxes() {
  const cfg = getSampleActionConfig();
  if (!cfg) return;
  const grid = cfg.row.querySelector('.sample--klassik-grid');
  if (!grid) return;

  // Urzustand der leeren Box einmalig als Vorlage sichern
  if (!sampleBoxTemplateHTML) {
    const pristineBox = grid.querySelector('.sample-modal-klassik:not(.filled)');
    if (pristineBox) sampleBoxTemplateHTML = pristineBox.outerHTML;
  }

  const filled = grid.querySelectorAll('.sample-modal-klassik.filled').length;

  // Ziel-Boxenzahl: ohne Auswahl 1 Box; nach dem 1. Muster oeffnet sich
  // die 3er-Staffel (2 weitere Boxen); ab dann immer genau 1 leere Box
  // (Muster 4+ zum reduzierten Preis)
  let target;
  if (filled === 0) {
    target = 1;
  } else {
    target = Math.max(3, filled + 1);
  }

  // Leere Boxen ergaenzen bzw. ueberzaehlige (nur leere) entfernen
  while (grid.querySelectorAll('.sample-modal-klassik').length < target && sampleBoxTemplateHTML) {
    grid.insertAdjacentHTML('beforeend', sampleBoxTemplateHTML);
  }
  let boxes = Array.from(grid.querySelectorAll('.sample-modal-klassik'));
  for (let i = boxes.length - 1; i >= 0 && boxes.length > target; i--) {
    if (!boxes[i].classList.contains('filled')) {
      boxes[i].remove();
      boxes.splice(i, 1);
    }
  }

  // Labels ("3,79 €" / "GRATIS" / reduzierter Preis) und Checkout-Preise
  // je Position: jedes 3. Muster gratis, alle uebrigen voller Preis
  boxes = Array.from(grid.querySelectorAll('.sample-modal-klassik'));
  boxes.forEach(function (box, idx) {
    const pos = idx + 1;
    const isFree = pos % 3 === 0;
    const boxPrice = isFree ? 0 : cfg.price;
    const label = box.querySelector('.muster-discount-text');
    if (label) {
      if (filled === 0) {
        label.textContent = '';
        label.classList.remove('is-free');
        label.style.display = 'none';
      } else {
        label.textContent = isFree ? cfg.freeLabel : formatMoney(boxPrice);
        label.classList.toggle('is-free', isFree);
        label.style.display = 'block';
      }
    }
    if (box.classList.contains('filled')) {
      box.setAttribute('data-discounted-price', boxPrice);
    } else {
      box.removeAttribute('data-discounted-price');
    }
  });

  handleSampleProductPrices();
}

function handleSampleProductPrices() {
  const cfg = getSampleActionConfig();
  if (!cfg) return;
  const filledBoxes = document.querySelectorAll('modal-opener.sample-modal-klassik.filled');
  const priceEle = document.querySelector('.price .price__sale .price-item--sale') || document.querySelector('.price .price__regular .price-item--regular');
  const cmpPriceEle = document.querySelector('.price .price__sale .price-item--regular');
  const salebadgeEle = document.querySelector('.badge.price__badge-sale');

  // Staffel: jedes 3. Muster gratis (Alwin 05.09.2026), sonst voller Preis
  const totalQty = filledBoxes.length;
  const freeQty = Math.floor(totalQty / 3);
  const fullQty = totalQty - freeQty;
  const totalPrice = fullQty * cfg.price;

  if (priceEle) {
    priceEle.textContent = formatMoney(totalQty > 0 ? totalPrice : cfg.price);
  }
  // Kein Streichpreis, keine Spar-Badge (Alwin 17.08.2026): Die GRATIS-Box sagt
  // schon, was der Vorteil ist — ein zweiter Rabatt-Hinweis daneben verwirrt nur.
  if (cmpPriceEle) cmpPriceEle.style.display = 'none';
  if (salebadgeEle) salebadgeEle.classList.add('hidden');
}

/* === 3-fuer-2: Warenkorb-Repricing ===
   _price wird beim Hinzufuegen fixiert. Loescht oder aendert der Kunde
   Muster-Positionen im Warenkorb, muss die Gratis-Verteilung neu berechnet
   werden (jedes 3. Stueck gratis) — sonst bliebe z.B. ein
   0-€-Muster ohne zwei bezahlte uebrig. Zusaetzlich rechnet creatDraftOrder()
   beim Checkout stueckgenau neu (buildSampleDraftLines) als verbindliche
   Preis-Wahrheit. */
function getSampleUnitPrice(sampleItems) {
  let unit = 0;
  sampleItems.forEach(function (item) {
    unit = Math.max(unit, Number(item.properties['_unit_price']) || 0, Number(item.properties['_price']) || 0);
  });
  return unit || (sampleItems[0] ? sampleItems[0].final_price : 0);
}

function getSampleDiscountPercent(sampleItems) {
  let pct = 0;
  sampleItems.forEach(function (item) {
    pct = Math.max(pct, Number(item.properties['_discount_percent']) || 0);
  });
  if (!pct) {
    const cfg = getSampleActionConfig();
    pct = cfg ? cfg.discountPercent : 0;
  }
  return pct || 50;
}

function buildSampleRepricePlan(items) {
  const sampleItems = items.filter(function (item) { return item.properties && item.properties['_sampleProducts']; });
  if (!sampleItems.length) return [];
  const totalQty = sampleItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);
  const unitPrice = getSampleUnitPrice(sampleItems);
  const pct = getSampleDiscountPercent(sampleItems);
  const reducedPrice = Math.round(unitPrice * (100 - pct) / 100);
  // Staffel: jedes 3. Stueck gratis (Alwin 05.09.2026), sonst voller Preis.
  // Vergabe an ganze Lines in Cart-Reihenfolge (neueste zuerst).
  let freeLeft = Math.floor(totalQty / 3);
  const changes = [];
  sampleItems.forEach(function (item) {
    let target = unitPrice;
    if (freeLeft >= item.quantity) {
      target = 0;
      freeLeft -= item.quantity;
    }
    const current = Number(item.properties['_price']) || 0;
    if (current !== target || !item.properties['_unit_price'] || !item.properties['_discount_percent']) {
      const props = Object.assign({}, item.properties);
      props['_price'] = String(target);
      props['_unit_price'] = String(unitPrice);
      props['_discount_percent'] = String(pct);
      changes.push({ key: item.key, quantity: item.quantity, properties: props });
    }
  });
  return changes;
}

function buildSampleDraftLines(items) {
  const sampleItems = items.filter(function (item) { return item.properties && item.properties['_sampleProducts']; });
  const lines = [];
  if (!sampleItems.length) return lines;
  const totalQty = sampleItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);
  const unitPrice = getSampleUnitPrice(sampleItems);
  const pct = getSampleDiscountPercent(sampleItems);
  const reducedPrice = Math.round(unitPrice * (100 - pct) / 100);
  // Stueckgenau: jedes 3. Stueck gratis, alle uebrigen voller Preis —
  // teil-belegte Lines werden in mehrere Draft-Lines gesplittet
  let freeLeft = Math.floor(totalQty / 3);
  sampleItems.forEach(function (item) {
    const freeQty = Math.min(freeLeft, item.quantity);
    freeLeft -= freeQty;
    const paidQty = item.quantity - freeQty;
    const makeLine = function (qty, priceCents) {
      const attrs = [];
      Object.entries(item.properties).forEach(function (entry) {
        attrs.push({ key: entry[0], value: entry[0] === '_price' ? String(priceCents) : entry[1].toString() });
      });
      if (!item.properties['_unit_price']) attrs.push({ key: '_unit_price', value: String(unitPrice) });
      if (!item.properties['_discount_percent']) attrs.push({ key: '_discount_percent', value: String(pct) });
      return {
        variantId: item.variant_id,
        amount: priceCents / 100,
        quantity: qty,
        currency_code: Shopify.currency?.active || 'EUR',
        customAttributes: attrs
      };
    };
    if (paidQty > 0) lines.push(makeLine(paidQty, unitPrice));
    if (freeQty > 0) lines.push(makeLine(freeQty, 0));
  });
  return lines;
}

let sampleRepriceRunning = false;
let sampleRepricePending = false;
function repriceSampleCartItems() {
  if (sampleRepriceRunning) {
    sampleRepricePending = true;
    return;
  }
  sampleRepriceRunning = true;
  const changeUrl = (window.routes && routes.cart_change_url) || '/cart/change.js';
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(async function (cart) {
      const changes = buildSampleRepricePlan(cart.items);
      if (!changes.length) return;
      const cartComponent = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
      for (let idx = 0; idx < changes.length; idx++) {
        const change = changes[idx];
        const isLast = idx === changes.length - 1;
        const body = { id: change.key, quantity: change.quantity, properties: change.properties };
        if (isLast && cartComponent) {
          body.sections = cartComponent.getSectionsToRender().map(function (s) { return s.section; });
          body.sections_url = window.location.pathname;
        }
        const resp = await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); });
        if (isLast && cartComponent && resp.sections) {
          cartComponent.getSectionsToRender().forEach(function (section) {
            const container = document.getElementById(section.id);
            const elementToReplace = (container && container.querySelector(section.selector)) || container;
            if (elementToReplace && resp.sections[section.section]) {
              elementToReplace.innerHTML = cartComponent.getSectionInnerHTML(resp.sections[section.section], section.selector);
            }
          });
        }
      }
    })
    .catch(function (e) { console.error('Muster-Repricing fehlgeschlagen', e); })
    .finally(function () {
      sampleRepriceRunning = false;
      if (sampleRepricePending) {
        sampleRepricePending = false;
        repriceSampleCartItems();
      }
    });
}

// Initialer Sync (Preisanzeige + Label-Zustand) + Cart-Repricing-Hook
function initSampleAction() {
  syncSampleBoxes();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { repriceSampleCartItems(); });
  }
}
if (document.readyState !== 'loading') {
  initSampleAction();
} else {
  document.addEventListener('DOMContentLoaded', initSampleAction);
}

function SampleProductQuickViewSlider(){
  let sliderEle = document.querySelectorAll('[data-sample-variant-quick-view-slider]');
  if(!sliderEle.length) return;

  for (let i=0; i<sliderEle.length; i++){
    let mainSlider = sliderEle[i];

    if(mainSlider){
      let swiper = new Swiper(mainSlider, {
        spaceBetween: 15,
        slidesPerView: 1,
        watchSlidesProgress: true,
        pagination: {
          el: mainSlider.querySelector(".swiper-pagination"),
          clickable: true
        },
      });
    }
  }
}

function formatMoney(cents) {
  const formatter = new Intl.NumberFormat(`${Shopify.locale}-${Shopify.country}`, {
    style: 'currency',
    currency: Shopify.currency?.active
  });
  return formatter.format(cents / 100);
}


 // value proposition Multi Image after before scroll
document.querySelectorAll(".value-proposition-images").forEach(block => {
  const container = block.querySelector(".value-propos-multiimg-container");
  const slider = block.querySelector(".value-proposition-slider");

  slider.addEventListener("input", (e) => {
    container.style.setProperty("--position", `${e.target.value}%`);
  });
});

// --- Swiper initialization ---
let vpSwiper;
if (document.querySelector(".value-proposition-wrap")) {
  vpSwiper = new Swiper(".value-proposition-wrap", {
    loop: false,
    slidesPerView: 1.1,
    spaceBetween: 30,
    grabCursor: true,

    navigation: {
      nextEl: ".value-proposition-wrap .swiper-button-next",
      prevEl: ".value-proposition-wrap .swiper-button-prev",
    },
    pagination: {
      el: ".value-proposition-multi-image .swiper-pagination",
      clickable: true,
      type: "bullets",
    },
    breakpoints: {
      320: { slidesPerView: 1,spaceBetween:10},
      480: { slidesPerView: 1.5, spaceBetween: 30},  
      750: { slidesPerView: 2.1, spaceBetween: 30 },
      990: { slidesPerView: 2.5, spaceBetween: 30 },
      1199: { slidesPerView: 3, spaceBetween: 25 },
    },
  });

  // --- Disable Swiper dragging while user slides range ---
  document.querySelectorAll(".value-proposition-slider").forEach(slider => {
    slider.addEventListener("touchstart", () => {
      vpSwiper.allowTouchMove = false;
    }, { passive: true });

    slider.addEventListener("touchend", () => {
      vpSwiper.allowTouchMove = true;
    }, { passive: true });

    // optional, helps when user drags slowly
    slider.addEventListener("touchcancel", () => {
      vpSwiper.allowTouchMove = true;
    }, { passive: true });
  });
}

